{
  "header": {
    "title": "Leader insights",
    "description": "Dive into feedback for different leaders",
    "exportButton": "Export"
  },
  "emptyState": {
    "company": {
      "title": "No data collected yet",
      "description": "Your journey starts here! Once employees begin sharing feedback for first month, you’ll see insights and trends appear"
    },
    "directReports": {
      "title": "No direct reports",
      "description": "You don’t have any direct reports assigned to you, but you can still participate in surveys and share valuable feedback!",
      "bottomAction": {
        "label": "If you think this is a mistake, contact your manager",
        "helpText": "Help text"
      }
    }
  },
  "datePicker": {
    "currentMonth": "This month",
    "lastMonth": "Last month",
    "monthCount": "{{monthCount}} months ago"
  },
  "leaderDropdown": {
    "triggerLabel": "Leader",
    "searchPlaceholder": "Find a leader"
  },
  "columnDropdown": {
    "triggerLabel": "Columns",
    "options": {
      "showAll": "Show all columns",
      "hideAll": "Hide all columns"
    }
  },
  "departmentDropdown": {
    "triggerLabel": "Department"
  },
  "tabs": {
    "allReports": "All reports",
    "directReports": "Direct reports"
  },
  "columns": {
    "leaderName": "Leader Name",
    "department": "Department",
    "averageScore": "Average Score",
    "enps": "eNPS",
    "reportCount": "Report Count",
    "participationRate": "Participation Rate"
  },
  "loadMoreButton": "Loading more data",
  "labels": {
    "leader": "Leader",
    "noResults": "No results"
  },
  "help": {
    "noResults": "No results found"
  },
  "loadingMoreData": "Loading more data",
  "leaderInsightsDetailsSection": {
    "name": "Leader Name",
    "department": "Department",
    "averageScore": "Average Score",
    "enps": "eNPS",
    "reportCount": "Report Count",
    "participationRate": "Participation Rate"
  },
  "detailsPage": {
    "header": {
      "name": "{{name}} Team",
      "department": "{{department}} team",
      "backButton": "Back to Leader insights",
      "seeProfileButton": "See profile",
      "exportButton": "Export"
    },
    "tabs": {
      "allReports": "All reports",
      "directReports": "Direct reports"
    },
    "leaderMetrics": {
      "title": "Leader’s metrics",
      "category": {
        "enps": {
          "name": "eNPS",
          "helpText": "Help text"
        },
        "averageScore": {
          "name": "Average score",
          "helpText": "Help text"
        },
        "participationRate": {
          "name": "Team participation rate",
          "helpText": "Help text"
        }
      },
      "chart": {
        "title": "Job satisfaction score"
      }
    },
    "teamMetrics": {
      "title": "Team averaged metrics",
      "scoreTitle": "{{name}}'s team",
      "companyAverageTitle": "Company average"
    },
    "keysInsights": {
      "title": "Key insights",
      "strengths": {
        "title": "Strengths",
        "tooltipTitle": "Help text"
      },
      "growthAreas": {
        "title": "Growth areas",
        "tooltipTitle": "Help text"
      }
    },
    "directReport": {
      "title": "Direct-report leaders",
      "empty": {
        "title": "No direct-report leaders",
        "description": "This leader doesn't have any subordinate leaders, or data didn't load yet"
      }
    }
  }
}
